import "./HistoriesDetailsDialog.css";
import 'react-medium-image-zoom/dist/styles.css'
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import ReactJson from 'react-json-view';
import Zoom from 'react-medium-image-zoom'
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import WifiProtectedSetupIcon from '@mui/icons-material/WifiProtectedSetup';
import Box from '@mui/material/Box';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import DangerousIcon from '@mui/icons-material/Dangerous';
import Button from '@mui/material/Button';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import Pagination from '@mui/material/Pagination';

import {
    FormatDate,
    IsEmptyString,
    IsObject,
} from '../../../libraries/Tool';

import {
    RunScript,
    GetHistoriesID,
    CloseBrowsers,
} from '../../../services/Workspace.service';

import {
    GetHistoriesDetails,
} from '../../../services/Schedule.service';
import { getEndpointURL } from '../../../services/config';

import NoScreenshot from '../../../libraries/Images/noScreenshot.png';

const endpointURL = getEndpointURL();

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function HistoriesDetailsDialog(props) {

    const { translate, SnackbarAlert, UserInfor, open, mode, scriptID, scriptName, scriptsteps, hisInfor, handleClose } = props;
    const [statusCd, setStatusCd] = React.useState(0); // 0: Running, 1: Success. 2: Error
    const [historiesMode, setHistoriesMode] = React.useState(0); // 1: Run scripts, 2: Debug scripts
    const [historiesDetails, setHistoriesDetails] = React.useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [pageCount, setPageCount] = React.useState(0);
    const [page, setPage] = React.useState(0);

    const historiesDetailsRef = React.useRef([]);

    const ProgressIcon = ({ statusCd }) => (
        <>
            {statusCd === 0 && <WifiProtectedSetupIcon className="running-icon" />}
            {statusCd === 1 && <CheckCircleIcon color="success" />}
            {statusCd === 2 && <ErrorIcon color="error" />}
        </>
    )

    const ArrowsIcon = ({ index }) => {
        let icons = [];
        for(var i = 0; i < index; i++){
            icons.push(<span className="material-symbols-outlined" style={{ width: 24, opacity: .5 }}>{((i === (index - 1)) ? 'subdirectory_arrow_right' : '')}</span>);
        }
        return icons;
    }

    const handleClickClose = () => {
        handleClose();
    }

    const hanleClickStop = () => {
        setHistoriesMode(0);
        let event = new Event("stop", {});
        document.dispatchEvent(event);
    }

    const hanleClickRun = () => {
        setHistoriesMode(1);
        setTimeout(() => {
            handleRunScripts();
        }, 500);
    }

    const InsertHistoriesDetails = async (historiesDetails, scriptSteps, index) => {
        let _historiesDetails = await JSON.parse(JSON.stringify(historiesDetails));
        await _historiesDetails.push({
            updatedDt: ''
            ,historiesID: ''
            ,historiesDetailsID: ''
            ,statusCd: 0
            ,name: scriptSteps[index].name
            ,title: scriptSteps[index].title
            ,index: scriptSteps[index].index
            ,screenshot: (scriptSteps[index]?.options?.screenshot?.value ? 1 : 0)
            ,outputKey: (scriptsteps[index]?.output?.key ? scriptsteps[index]?.output?.key : null)
            ,output:  ''
            ,outputType: ''
        })
        return _historiesDetails;
    }

    const UpdateHistoriesDetails = async (historiesDetails, result) => {
        let _historiesDetails = await JSON.parse(JSON.stringify(historiesDetails));
        let index = await _historiesDetails?.findIndex(item => item.statusCd === 0 && !item.output);
        _historiesDetails[index].updatedDt = FormatDate(new Date(), "yyyy-MM-dd HH:mm:ss");
        _historiesDetails[index].historiesID = result.historiesID;
        _historiesDetails[index].historiesDetailsID = result.historiesDetailsID;
        _historiesDetails[index].statusCd = result.statusCd;
        _historiesDetails[index].output = result.output;
        _historiesDetails[index].outputType = result.outputType;
        return _historiesDetails;
    }

    const handleRunScripts = async () => {
        try {
            let errorIs;
            document.addEventListener("stop", function(event) {
                window.stop();
            }, false);
            await setStatusCd(0);
            historiesDetailsRef.current = await [];
            let scriptSteps = await JSON.parse(JSON.stringify(scriptsteps));
            const historiesID =  await new Promise((resolve, reject) => {
                GetHistoriesID(scriptID)
                .then(res => resolve(res.data.historiesID))
                .catch(err =>  reject(err))
            })
            for( let index = 0 ; index < scriptSteps.length ; index++)  {
                if(!scriptSteps[index].ignore) {
                    historiesDetailsRef.current = await InsertHistoriesDetails(historiesDetailsRef.current, scriptSteps, index, historiesID)
                    await setHistoriesDetails(historiesDetailsRef.current);
                    const result = await new Promise((resolve, reject) => {
                        RunScript(scriptID, historiesID, scriptSteps, index)
                        .then(res => resolve(res.data))
                        .catch(err =>  reject(err))
                    })
                    if(scriptSteps[index]?.output?.key) {
                        scriptSteps[index].output.value = await result.output;
                    }
                    if(result.statusCd === 2) {
                        index = await scriptSteps.length;
                        errorIs = await true;
                    } else {
                        index = await result.index;
                    }
                    historiesDetailsRef.current = await UpdateHistoriesDetails(historiesDetailsRef.current, result)
                    await setHistoriesDetails(historiesDetailsRef.current);
                }
            }
            if(!errorIs) {
                await setStatusCd(1);
            } else {
                await setStatusCd(2);
            }
            await setHistoriesMode(0);
            await CloseBrowsers(scriptSteps);
        }
        catch (e) {
            // console.log(e);
            historiesDetailsRef.current[historiesDetailsRef.current.length - 1].statusCd = 2;
            await setStatusCd(2);
            await setHistoriesMode(0);
        }
    }

    const copyToClipboard = (target) => {
        navigator.clipboard.writeText(target.src);
        props.dispatch({ 
            type: 'UPDATE_SNACKBARALERT', 
            SnackbarAlert: {
                open: true,
                severity: 'success',
                message: translate('copiedtoclipboard'),
                handleClose: () => handleCloseSnackbarAlert()
            } 
        });
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const handleChangeRowsPerpage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    }

    const handleChangePage = (event, value) => {
        setPage(parseInt(value) - 1);
      };

    const handleViewHistoriesDetails = () => {
        GetHistoriesDetails(hisInfor.historiesID, rowsPerPage, page)
        .then(async res => {
            // console.log(res);
            setPageCount(Math.ceil(res.data.datas[0][0]?.count / rowsPerPage));
            let details = await res.data.datas[1]?.map(item => {
                item.output = IsObject(item.output) ? JSON.parse(item.output) : item.output;
                return item;
            });
            setHistoriesDetails(details);
        })
    }

    useEffect(() => {
        if(mode === 3) handleViewHistoriesDetails();
    }, [page, rowsPerPage])

    useEffect(() => {
        if(historiesMode === 1 || historiesMode === 2) setHistoriesDetails([]);
    }, [historiesMode])

    useEffect(() => {
        if(open && mode !== 0) {
            switch (mode) {
                case 1:
                    setHistoriesMode(1);
                    handleRunScripts();
                    break;
                case 2:
                    break;
                case 3:
                    setHistoriesMode(3);
                    setStatusCd(hisInfor.statusCd);
                    handleViewHistoriesDetails();
                    break;
            }
        }
    }, [open])

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClickClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', boxShadow: 'none' }} color="primary">
            <Toolbar>
                <ProgressIcon statusCd={statusCd} />
                <Typography sx={{ ml: 1, flex: 1, textAlign: "left" }} variant="h6" component="div">
                {scriptName}
                </Typography>
                <Box className="button-group">
                    {(historiesMode === 0) && 
                    <Button 
                        variant="contained" 
                        disableElevation 
                        startIcon={<PlayCircleFilledWhiteOutlinedIcon />} 
                        color="success" 
                        onClick={hanleClickRun}
                    >{translate('run')}</Button>}
                    {(historiesMode === 1 || historiesMode === 2) && 
                    <Button 
                        variant="contained" 
                        disableElevation 
                        startIcon={<DangerousIcon />} 
                        color="error" 
                        onClick={hanleClickStop}
                    >{translate('stop')}</Button>}
                    {(historiesMode === 3) &&
                    <Box display="flex" alignItems="center" gap={2}>
                        <div>
                            <label>{translate('rowsperpage')}:</label>
                            <select value={rowsPerPage} onChange={handleChangeRowsPerpage} className="rowsPerPage">
                                {[50, 100, 200].map(item => (
                                    <option key={item} value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                        <Pagination count={pageCount} page={page + 1} onChange={handleChangePage} shape="rounded" color="info" />
                    </Box>}
                </Box>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClickClose}
                    aria-label="close"
                    disabled={historiesMode === 1 || historiesMode === 2} 
                >
                    <CloseIcon />
                </IconButton>
            </Toolbar>
            </AppBar>
            <Box maxWidth="lg" sx={{ p: "10px", m: "0 auto", width: "100%", overflow: "auto" }}>
                {historiesDetails.map((historiesDetail, index) => (
                    <Accordion key={index}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <Box display="flex" alignItems="end" gap={1} flex={6}>
                                <ProgressIcon statusCd={historiesDetail.statusCd} />
                                <Divider orientation="vertical" flexItem />
                                <ArrowsIcon index={historiesDetail.index} />
                                <Typography>{historiesDetail.title}</Typography>
                                <Typography variant="caption" sx={{ opacity: 0.3 }}>{historiesDetail.outputKey}</Typography>
                            </Box>
                            <Box flex={1}>
                                <Typography sx={{ opacity: 0.3, whiteSpace: "nowrap" }}>{historiesDetail.updatedDt}</Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            {!IsEmptyString(historiesDetail?.output) && 
                            <Box className="histories-output">
                                {(historiesDetail.outputType === 'object') ?
                                <ReactJson 
                                    src={historiesDetail.output}
                                    name={false}
                                    style={{ 
                                        maxHeight: "400px",
                                        overflow: "auto"
                                    }}
                                    displayObjectSize={false}
                                    displayDataTypes={false}
                                    displayArrayKey={false}
                                    enableClipboard={copyToClipboard}
                                /> :
                                <Typography
                                    style={{ whiteSpace: "pre" }}
                                >{
                                    (historiesDetail.outputType === 'undefined') ? 'undefined' : 
                                    (historiesDetail.outputType === 'number') ? historiesDetail.output : 
                                    `"${historiesDetail.output?.toString()}"`
                                }</Typography>}
                            </Box>}
                            {(historiesDetail.screenshot === 1) && (historiesDetail.statusCd === 1) && 
                            <Box className="histories-screenshot">
                                <Zoom>
                                    <img
                                        src={
                                            `${endpointURL}/tmp/${historiesDetail.createdID ? historiesDetail.createdID : UserInfor.userID}/tmp/downloads/${scriptID}/${historiesDetail.historiesID}/${historiesDetail.historiesDetailsID}.png`
                                        }
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src=NoScreenshot;
                                        }}
                                        height="300px"
                                    />
                                </Zoom>
                            </Box>}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </Dialog>
    );
}
function mapStateToProps(state) {
    return {
        SnackbarAlert: state.SnackbarAlert,
        UserInfor: state.UserInfor,
    }
}
export default connect(mapStateToProps)(withTranslate(HistoriesDetailsDialog));

// const runScripts = async () => {
//     for( let index = 0 ; index < scriptsteps.length ; index++)  {
//         await document.body.dispatchEvent(
//             new CustomEvent("runScript", {
//                 detail: {
//                     scriptsteps, 
//                     index,
//                 }, 
//                 bubbles: true, 
//                 cancelable: false
//             })
//         );
//         const response = await new Promise(resolve => {
//             document.addEventListener('response', function (response) {
//                 resolve(response.detail);
//             }, { once: true })
//         });
//     }
// }
